import { useSyncExternalStore } from 'react'
import { StorageKey } from '@/lib/storage'

const HINT_SEEN_VALUE = 'true'
const listeners = new Set<() => void>()

function readShareHintSeen(): boolean {
  const value = window.localStorage.getItem(StorageKey.ShareHintSeen)
  if (value === null) return false
  if (value !== HINT_SEEN_VALUE) {
    throw new Error(`Share hint state must be "${HINT_SEEN_VALUE}", received "${value}"`)
  }
  return true
}

function subscribe(listener: () => void): () => void {
  const onStorage = (event: StorageEvent) => {
    if (event.key === StorageKey.ShareHintSeen) listener()
  }
  listeners.add(listener)
  window.addEventListener('storage', onStorage)
  return () => {
    listeners.delete(listener)
    window.removeEventListener('storage', onStorage)
  }
}

export function useShareHintSeen(): boolean {
  return useSyncExternalStore(subscribe, readShareHintSeen, () => false)
}

export function markShareHintSeen(): void {
  if (readShareHintSeen()) return
  window.localStorage.setItem(StorageKey.ShareHintSeen, HINT_SEEN_VALUE)
  listeners.forEach((listener) => listener())
}
